import { useMemo, useState } from 'react';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import InvestmentNoteFiltering from '../../../components/InvestmentNoteFiltering';
import WelcomeLine from '../../../components/WelcomeLine';
import { useInvestmentNotesQuery } from '../src/portfolioQueries';
import ListNote from './ListNote';
import PortfolioDashboard from './PortfolioDashboard';

const Portfolio = () => {
    const [page, setPage] = useState(1);
    const [themeIds, setThemeIds] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [allocatedCompleted, setAllocatedCompleted] = useState('allocated');
    const [filterKey, setFilterKey] = useState(false);

    const { data: profileData } = useProfileQuery();

    const params = useMemo(
        () => ({
            'filter[theme.id][]': themeIds,
            ...(searchString ? { 'filter[name]': searchString } : {}),
        }),
        [themeIds, searchString]
    );

    const { data, isFetching } = useInvestmentNotesQuery(page, params, allocatedCompleted);

    const filterInvestmentNotes = (values, themeList) => {
        const themes = themeList
            .map((theme) => (values[theme.name + 'Filter'] ? theme.value : null))
            .filter((t) => t !== null)
            .sort((a, b) => a - b);

        setThemeIds(themes);
        setSearchString(values.name || '');
        setPage(1);
        setFilterKey(!filterKey);
    };

    return (
        <div className="page-wrapper">
            <div className="dashboard-section container">
                <WelcomeLine name={profileData?.first_name || 'N/A'} />
                <div className="portfolio__summary-container">
                    <PortfolioDashboard />
                </div>
            </div>

            <div className="portfolio__listing container">
                <InvestmentNoteFiltering
                    filterInvestmentNotes={filterInvestmentNotes}
                />
                <ListNote
                    investmentNotes={data?.data}
                    pageCount={data?.last_page}
                    page={page}
                    setPage={setPage}
                    isFetching={isFetching}
                    setAllocatedCompleted={setAllocatedCompleted}
                />
            </div>
        </div>
    );
};

export default Portfolio;
